// removed by extract-text-webpack-plugin
module.exports = {"purchases":"purchases__purchases___3_whf","empty":"purchases__empty___2nrWx","purchaseList":"purchases__purchaseList___2o_ZC","nonEmptyPurchaseList":"purchases__nonEmptyPurchaseList___A9sEP","loadingPurchases":"purchases__loadingPurchases___1Gl06","header":"purchases__header___1sZPJ","heading":"purchases__heading___bDYoN","filters":"purchases__filters___1G9zp","filter":"purchases__filter___1FoDs","isActive":"purchases__isActive___1_rIS"};


//////////////////
// WEBPACK FOOTER
// ./src/purchases/purchases.scss
// module id = 1263
// module chunks = 0